<template>
  <div class="wt2-make-new-storyboard">
    <div class="-title-wrapper">
      <div class="-title wt2-text-2xl">
        {{ 'generic.MAKE_NEW_STORYBOARD' | culture }}
      </div>
    </div>
    <div class="-content">
      <div class="-name">
        <wt-text-field
          v-model="storyboardName"
          :mandatory="errorMessage.length > 0"
          :placeholder="'makeNewStoryboardDialog.insertTitle' | culture"
          :errorMessage="errorMessage"
        />
      </div>
      <div class="-programmer">
        <wt-brands-dropdown
          :current-brand.sync="currentBrand"
          :enable-stash="true"
        />
      </div>
      <div class="-aspect-ratios-wrapper">
        <wt-aspect-ratio-selector
          :aspect-ratios="aspectRatios"
          :default-aspect-ratio="defaultAspectRatio"
          @select="setAspectRatio"
        />
      </div>
    </div>
    <div class="-actions" v-tab-guard>
      <wt-button
        class="-min-width-unset"
        tabindex="0"
        type="transparent"
        :text="'makeNewStoryboardDialog.cancel' | culture"
        @click="closeModal"
      />
      <wt-button
        :disabled="creatingStoryBoard"
        :text="'generic.MAKE_NEW_STORYBOARD' | culture"
        tabindex="-1"
        @click="onCreateStory"
      />
    </div>
  </div>
</template>

<script>
import app from 'app';
import { mapActions } from 'vuex';
import WtBrandsDropdown from '#/components/dropdowns/wtBrandsDropdown.vue';

export default {
  name: 'wtMakeNewStoryboard',
  components: { WtBrandsDropdown },
  store() {
    return app.rootStore;
  },

  data() {
    return {
      currentBrand: this.$store.getters['user/selectedOrganization'].brands[0],
      storyboardName: '',
      errorMessage: '',
      selectedAspectRatioKey: null,
      creatingStoryBoard: false,
    };
  },

  props: {
    closeModal: { type: Function, required: true },
    // used to identify where opened from
    page: { type: String, required: false },
  },

  computed: {
    aspectRatios() {
      const rv = {};

      Object.keys(app.ASPECT_RATIOS).forEach((arKey) => {
        if (
          this.currentBrand.themes.find((theme) => theme.aspectRatio === arKey)
        ) {
          rv[arKey] = app.ASPECT_RATIOS[arKey];
        }
      });

      return rv;
    },

    defaultAspectRatio() {
      let rv = app.DEFAULT.ASPECT_RATIO;
      const aspectRatioKeys = Object.keys(this.aspectRatios);
      const last =
        app.remoteStash.get('lastAspectRatio') || app.DEFAULT.ASPECT_RATIO;

      if (last in this.aspectRatios) {
        rv = last;
      } else if (aspectRatioKeys.length) {
        rv = aspectRatioKeys[0];
      }

      return rv;
    },
  },

  methods: {
    ...mapActions(['CREATE_STORYBOARD']),

    setAspectRatio(newAspectRatio) {
      this.selectedAspectRatioKey = newAspectRatio;
      app.remoteStash.set('lastAspectRatio', newAspectRatio);
    },

    onCreateStory: _.debounce(
      function () {
        app.analytics('clickedCreateNewStoryboard', {
          source: 'button',
          page: this.page || 'unknown',
        });

        if (!this.storyboardName) {
          this.errorMessage = app.culture.makeNewStoryboardDialog.titleError;
        } else {
          const theme = this.currentBrand.themes.find(
            (theme) => theme.aspectRatio === this.selectedAspectRatioKey
          );

          this.creatingStoryBoard = true;
          this.CREATE_STORYBOARD({
            title: this.storyboardName,
            programmerId: this.currentBrand.programmerId,
            brandId: this.currentBrand.brandId,
            themeId: theme.themeId,
            aspectRatio: this.selectedAspectRatioKey,
            publishedDate: Date.now(),
          }).finally(() => {
            this.creatingStoryBoard = false;
          });
        }
      },
      app.TIME.MENTAL.λ,
      { leading: true, trailing: false }
    ),
  },

  watch: {
    storyboardName() {
      this.errorMessage = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.wt2-make-new-storyboard {
  padding-top: 60px;
  position: relative;
  min-height: 280px;
  display: flex;
  align-items: center;
  flex-direction: column;
  .-title-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;

    .-title {
      margin-bottom: 40px;
      position: relative;
    }
  }

  .-content {
    width: 300px;
    .-name {
      margin-bottom: 40px;
    }
    .-programmer {
      margin-bottom: 40px;
    }
    .wt2-text-field {
      &/deep/ {
        input {
          height: 50px;
        }
      }
    }
  }

  .-actions {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .-programmers-wrapper {
    margin-bottom: 40px;
  }

  .-aspect-ratios-wrapper {
    margin-bottom: 80px;
  }

  .-name /deep/ {
    .-error-message {
      position: absolute;
      bottom: -20px;
    }
  }
}
</style>
